module.exports = __webpack_public_path__ + "static/img/stock-photo-group-of-chef-preparing-food-in-the-kitchen-of-a-restaurant-564164815.bcf84bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stock-photo-group-of-chef-preparing-food-in-the-kitchen-of-a-restaurant-564164815.jpg
// module id = XCue
// module chunks = 1